import { AppPageNames, AppRoutePaths } from "@/constants/appRoutes";
import { FeatureName } from "@/models/userProfile.model";

export const MENU_CLOSE_DELAY = 300;

export const ACTION_MENU_PLACEMENT_DEFAULT = "right-start";
export const ACTION_MENU_PLACEMENT_RIGHT_CLICK = "bottom-end";

export const NAV_MENU_ITEMS = [
  {
    label: AppPageNames.home,
    value: AppRoutePaths.home,
    icon: "icon-home",
    activeIcon: "icon-home-filled",
    featureName: FeatureName.homePage
  }, 
  {
    label: AppPageNames.interactions,
    value: AppRoutePaths.playback,
    icon: "icon-play-outline",
    activeIcon: "icon-play",
    featureName: null
  },
  {
    label: AppPageNames.scoring,
    value: AppRoutePaths.scoring,
    icon: "icon-list-check",
    activeIcon: "icon-list-check",
    featureName: FeatureName.scoringScorecardsPage
  },
  {
    label: AppPageNames.promptStudio,
    value: AppRoutePaths.promptStudio,
    icon: "icon-books-outline",
    activeIcon: "icon-books",
    featureName: FeatureName.promptStudioPage
  },
];

export const NAV_VIEW_MENU_ITEMS = [
  { 
    label: AppPageNames.overview, 
    value: AppRoutePaths.overview,
    featureName: null, 
  },
  { 
    label: AppPageNames.objections,
    value: AppRoutePaths.objections,  
    featureName: FeatureName.objectionsTab 
  },
  { 
    label: AppPageNames.sentiment,
    value: AppRoutePaths.sentiment, 
    featureName: FeatureName.sentimentTab
  },
  { 
    label: AppPageNames.performance,
    value: AppRoutePaths.performance,  
    featureName: FeatureName.performanceTab 
  },
  { 
    label: AppPageNames.topics,
    value: AppRoutePaths.topics,  
    featureName: null
  },
  { 
    label: AppPageNames.interactions,
    value: AppRoutePaths.interactions,  
    featureName: null,
   },
];

export const NAV_SCORING_MENU_ITEMS = [

];

// export const CHATBOT_PROMPTS_LIBRARY_DIALOG_SECTIONS: ITabMenuItem[] = [
//   {
//     id: ChatbotPromptTypes.template,
//     label: "Templates",
//     tooltip: "Pre-made prompts you can use as-is or customise."
//   },
//   {
//     id: ChatbotPromptTypes.custom,
//     label: "Custom",
//     tooltip: "Prompts created by you or others in your organisation."
//   },
//   {
//     id: ChatbotPromptTypes.bookmark,
//     label: "Bookmarks",
//     tooltip: "Prompts you’ve bookmarked for quick access."
//   },
// ];